<template>
  <div id="invoice" class="invoice">
    <div class="invoice-title">
      <span>POA</span>
    </div>
    <div class="bannerline">请下载此文件进行签名和上传</div>
    <div class="invoice-download mt24">
      <i class="el-icon-download" />
      <a>POA-US.pdf</a>
    </div>
    <div class="Upload">
      <el-upload
        ref="upload"
        class="upload"
        :action="uploadAction"
        :data="{}"
        :on-success="(response, file, fileList) => handleSuccess(response, file, fileList)"
        :multiple="true"
        :limit="9"
        accept=".jpg,.jpeg,.gif,.png,.bmp,.pic,.doc,.docx,.rar,.xls,.xlsx,.pdf,.zip"
        :headers="{'Authorization': token}"
        :file-list="fileList"
      >
        <img src="../../../../../../../assets/img/manage/settings/上传.png" width="24px" height="24px">
        <span class="Upload-name">上传POA</span>
        <span class="Upload-tip">大小不超过7MB</span>
      </el-upload>
    </div>
    <div class="foot-buttom">
      <button class="by-button--primary" @click="save">完成</button>
    </div>
  </div>
</template>

<script>
import define from '@/utils/define'
import {
  UploadOrderAttach,
  GetOrderAttach,
  CheckOrderComplete,
  UpdateAirConfirm
} from '../../../../../../../api/order.js'
import {
  getCookie
} from '@/utils/cookiejs'
export default {
  name: 'Invoice',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      uploadAction: '',
      fileList: [],
      token: '',
      data: {}
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    this.uploadAction = define.comUrl + '/api/file/Uploader/customer'
    this.token = getCookie('token')
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(data) {
      console.log('poa', data)
      this.data = data
      this.fileList = []
      GetOrderAttach(data.orderNo).then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            if (item.attachType === 11) {
              this.fileList.push({
                name: item.originName,
                fileId: item.buildName,
                url: item.url
              })
            }
          })
        }
      })
    },
    // 方法
    save() {
      if (this.fileList.length === 0) {
        return
      }
      var data = []
      this.fileList.forEach(item => {
        var attach = {
          objectId: this.data.orderNo,
          attachType: 11,
          originName: item.name,
          buildName: item.fileId,
          url: item.url,
		  uploadType: 1
        }
        data.push(attach)
      })
      UploadOrderAttach(data).then(res => {
        if (res.code === 200) {
          this.CheckOrderComplete()
        }
      })
    },
    CheckOrderComplete() {
      CheckOrderComplete(this.data.orderNo).then(res => {
		  if (res.code === 200 && !res.data) {
		    this.UpdateAirConfirm()
		  }
      })
    },
    UpdateAirConfirm() {
      UpdateAirConfirm(this.data.orderNo).then(res => {
		  if (res.code === 200) {
		    this.$emit('finish')
		  }
      })
    },
    handleSuccess(response, file, fileList) {
      if (response.code === 200) {
        this.fileList.push({
          name: file.name,
          fileId: response.data.name,
          url: response.data.url
        })
      }
    }
  }
}
</script>
<style scoped lang='scss'>
	.mt40 {
		margin-top: 40px;
	}

	.mt24 {
		margin-top: 24px;
	}

	.invoice {
		width: 964px;
		height: auto;
		background: #FFFFFF;
		border-radius: 8px;
		padding: 16px;
		text-align: left;

		.invoice-title {
			display: flex;
			justify-content: start;
			align-items: center;

			span {
				font-size: 18px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				color: #333333;
			}

			.invoice-label {
				background: rgba(239, 10, 10, 0.08);
				border-radius: 8px;
				padding: 4px 7px;
				margin-left: 8px;
				font-size: 13px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #EF0A0A;
			}
		}

		.bannerline {
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #333333;
			margin-top: 16px;
		}

		.p-title {
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #777777;
		}

		.p-title::before {
			content: "" !important;
			position: relative;
			top: -3px;
			display: inline-block;
			width: 4px;
			height: 4px;
			background: #777777;
			border-radius: 50%;
			margin-right: 8px;
		}

		.invoice-download {
			i {
				color: #027FFC;
				margin-right: 8px;
			}

			a {
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #027FFC;
				text-decoration: underline;
			}
		}

		.Upload {
			width: 916px;
			height: 24px;
			background: rgba(153, 153, 153, 0.06);
			border-radius: 8px;
			border: 1px dashed rgba(153, 153, 153, 0.56);
			display: flex;
			align-items: center;
			padding: 24px;
			margin: 16px 0;

			.Upload-name {
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #333333;
				margin: 0 32px 0 12px;
			}

			.Upload-tip {
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #AAAAAA;
			}
		}

		.foot-buttom {
			text-align: right;
			margin: 24px 0;
			padding-bottom: 24px;

			button {
				width: 120px;
				height: 40px;
			}
		}
	}
</style>
